(() => {
  const MANAGED_CODE_SELECTOR = '[data-consent-managed-code]';
  const PREFERENCES_TRIGGER_SELECTOR = '[data-cookie-preferences-trigger]';
  const BRAND_TEMPLATE_SELECTOR = '[data-cookie-consent-brand]';
  const FEATURE = [{ name: 'consent-tracking-api', version: '0.1' }];
  const ALLOWED_METHODS = {
    analytics: 'analyticsProcessingAllowed',
    marketing: 'marketingAllowed',
    preferences: 'preferencesProcessingAllowed',
  };
  const activeCategories = new Set();

  function isAllowed(category) {
    const method = ALLOWED_METHODS[category];
    const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    return Boolean(method && customerPrivacy && customerPrivacy[method]());
  }

  function makeExecutable(fragment) {
    fragment.querySelectorAll('script').forEach((inertScript) => {
      const script = document.createElement('script');

      [...inertScript.attributes].forEach((attribute) => {
        script.setAttribute(attribute.name, attribute.value);
      });
      script.async = inertScript.hasAttribute('async');
      script.textContent = inertScript.textContent;
      inertScript.replaceWith(script);
    });
  }

  function activate(template) {
    if (template.dataset.consentLoaded === 'true') return;

    const category = template.dataset.consentCategory;
    if (!isAllowed(category)) return;

    const fragment = template.content.cloneNode(true);
    const target = template.dataset.consentTarget === 'head' ? document.head : document.body;

    makeExecutable(fragment);
    target.appendChild(fragment);
    template.dataset.consentLoaded = 'true';
    activeCategories.add(category);
  }

  function syncManagedCode() {
    const revokedCategory = [...activeCategories].find((category) => !isAllowed(category));

    if (revokedCategory) {
      window.location.reload();
      return;
    }

    document.querySelectorAll(MANAGED_CODE_SELECTOR).forEach(activate);
  }

  function isVisible(element) {
    return Boolean(element && element.getClientRects().length);
  }

  function openPreferences() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      return window.privacyBanner.showPreferences();
    }

    const nativeManageButton = document.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (nativeManageButton) nativeManageButton.click();
    return undefined;
  }

  function placePreferencesTriggers(triggers) {
    const footer =
      document.querySelector('.footer__info') ||
      document.querySelector('.f\\:footer__bottom') ||
      document.querySelector('footer');

    if (!footer) return;

    triggers.forEach((trigger) => {
      if (!footer.contains(trigger)) footer.appendChild(trigger);
    });
  }

  function injectConsentBrand() {
    const brandTemplate = document.querySelector(BRAND_TEMPLATE_SELECTOR);
    const banner = document.querySelector('#shopify-pc__banner');
    const bannerBody = document.querySelector('.shopify-pc__banner__body');

    if (!brandTemplate || !banner || !bannerBody || bannerBody.querySelector('.cookie-consent-brand')) return;

    bannerBody.prepend(brandTemplate.content.cloneNode(true));
  }

  function observeConsentUi(updateVisibility) {
    const observedElements = new WeakSet();
    const attributeObserver = new MutationObserver(updateVisibility);

    const observeCurrentElements = () => {
      const banner = document.querySelector('#shopify-pc__banner');
      const preferences = document.querySelector('#shopify-pc__prefs');

      [banner, preferences].forEach((element) => {
        if (!element || observedElements.has(element)) return;

        attributeObserver.observe(element, {
          attributes: true,
          attributeFilter: ['class', 'hidden', 'style'],
        });
        observedElements.add(element);
      });

      updateVisibility();
    };

    const treeObserver = new MutationObserver(observeCurrentElements);
    treeObserver.observe(document.body, { childList: true, subtree: true });
    observeCurrentElements();
  }

  function connectPreferencesTrigger() {
    const nativeManageButton = document.querySelector('#shopify-pc__banner__btn-manage-prefs');
    const triggers = document.querySelectorAll(PREFERENCES_TRIGGER_SELECTOR);
    const privacyApiIsAvailable = window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';

    placePreferencesTriggers(triggers);
    if ((!privacyApiIsAvailable && !nativeManageButton) || !triggers.length) return false;

    const updateVisibility = () => {
      const consentUiIsOpen =
        isVisible(document.querySelector('#shopify-pc__banner')) ||
        isVisible(document.querySelector('#shopify-pc__prefs'));
      triggers.forEach((trigger) => {
        if (trigger.hidden !== consentUiIsOpen) trigger.hidden = consentUiIsOpen;
      });
    };

    triggers.forEach((trigger) => {
      if (trigger.dataset.cookiePreferencesConnected === 'true') return;

      trigger.addEventListener('click', () => {
        trigger.hidden = true;
        const result = openPreferences();

        if (result && typeof result.catch === 'function') {
          result.catch(() => {
            trigger.hidden = false;
          });
        }
      });
      trigger.dataset.cookiePreferencesConnected = 'true';
    });

    observeConsentUi(() => {
      injectConsentBrand();
      updateVisibility();
    });
    return true;
  }

  function initializePreferencesTrigger() {
    if (connectPreferencesTrigger()) return;

    const observer = new MutationObserver(() => {
      if (connectPreferencesTrigger()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initializeManagedCode() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures(FEATURE, (error) => {
      if (error) {
        console.warn('Customer privacy API could not be loaded. Consent-managed code remains blocked.');
        return;
      }

      syncManagedCode();
      document.addEventListener('visitorConsentCollected', syncManagedCode);
    });
  }

  initializePreferencesTrigger();
  initializeManagedCode();
})();
